import {
  PostTradeIdea,
  PostTradeIdeaComment,
  TradeIdea,
  TradeIdeaComment,
  TradeIdeaPostError,
  Trader,
  TraderStatus,
  ZingFlag,
  TradeIdeaRequestParams,
  PremiumIdeaRequestParams,
} from './entities';
import { Subscribable, Subscription } from '@benzinga/subscribable';
import { TradeIdeaRequest, TradeIdeaRequestEvent } from './request';
import { Session } from '@benzinga/session';
import { TradeIdeaFeed } from './feed';
import { SafePromise } from '@benzinga/safe-await';
import { PremiumIdeaFeed } from './premiumFeed';

export class TradeIdeaManager extends Subscribable<TradeIdeaRequestEvent> {
  private request: TradeIdeaRequest;
  private requestSubscription?: Subscription<TradeIdeaRequest>;

  constructor(session: Session) {
    super();
    this.request = new TradeIdeaRequest(session);
    // console.log("CREATE TRADE IDEA FEED: ", this.params);
  }

  public static getName = () => 'benzinga-trade-ideas';

  public createFeed(params: TradeIdeaRequestParams): TradeIdeaFeed {
    return new TradeIdeaFeed(params, this.request);
  }

  public premiumFeed(params: PremiumIdeaRequestParams, tableType: string): PremiumIdeaFeed {
    return new PremiumIdeaFeed(params, this.request, tableType);
  }

  public getTradeIdea = async (tradeIdeaId: string): SafePromise<TradeIdea> => {
    return this.request.getTradeIdea(tradeIdeaId);
  };

  public getTradersToReview = async (): SafePromise<Trader[]> => {
    return this.request.getTradersToReview();
  };

  public reviewTrader = async (trader: Trader, status: TraderStatus): SafePromise<any> => {
    return this.request.reviewTrader(trader, status);
  };

  public postTradeIdea = async (data: PostTradeIdea): SafePromise<TradeIdea, string, TradeIdeaPostError | Response> => {
    return this.request.postTradeIdea(data);
  };

  public postTradeIdeaComment = async (data: PostTradeIdeaComment): Promise<TradeIdeaComment | any> => {
    return this.request.postTradeIdeaComment(data);
  };

  public flag = async (trade_idea_id: number, type: string, reason: string | null = null): SafePromise<ZingFlag> => {
    return this.request.flag(trade_idea_id, type, reason);
  };

  public vote = async (tradeIdea: TradeIdea, type: 'upvote' | 'downvote'): Promise<any> => {
    return this.request.vote(tradeIdea, type);
  };

  public deleteTradeIdea = async (trade_idea_id: number) => {
    return this.request.deleteTradeIdea(trade_idea_id);
  };

  protected onFirstSubscription() {
    this.requestSubscription = this.request.listen(e => this.dispatch(e));
  }

  protected onZeroSubscriptions() {
    this.requestSubscription?.unsubscribe();
    this.requestSubscription = undefined;
  }
}
